export default "__VITE_ASSET__2634766a__"